import script from "./PerformanceChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./PerformanceChart.vue?vue&type=script&setup=true&lang=ts"

import "./PerformanceChart.vue?vue&type=style&index=0&id=7cfe4b66&lang=css"

const __exports__ = script;

export default __exports__